import { AVIVE } from '@rsos/capstone/src/constants/capabilities';

const hasAviveCapability = (activeCapabilities = {}) => {
  if (typeof activeCapabilities === 'object') {
    return Object.keys(activeCapabilities).find(k => {
      return `${k}`.startsWith(AVIVE);
    });
  }
  return false;
};

export default hasAviveCapability;
